import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import messages from 'vee-validate/dist/locale/vi';
import extendCustomRules from './custom-rules';

Validator.localize('vi', messages);
// Validator.localize(dictionary);

// Extend custom rules
extendCustomRules();

Vue.use(VeeValidate, {
  locale: 'en',
  fieldsBagName: 'formFields',
});



// WEBPACK FOOTER //
// ./src/plugins/vee-validate/index.js